<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"></h1>
<p>“The Pentagon’s secret study of the Vietnam war discloses that President Kennedy knew and approved of plans for the military coup d’état that overthrew President Ngo Dinh Diem in 1963. . . .</p>
<p>“ ‘Our complicity in his overthrow heightened our responsibilities and our commitments’ in Vietnam, the study finds. …”</p>
<p class="right"><span><span class="small-caps">THE PENTAGON PAPERS</span>, as published by<br/><em>The New York Times</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?2321283a